"use client";

import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";

const AboutPage: React.FC = () => {
  return (
    <motion.div
      className="py-8 sm:py-16 font-goodfont bg-transparent text-white min-h-screen"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <div className="container mx-auto px-4 max-w-5xl">
        <motion.h1
          className="text-3xl sm:text-4xl md:text-5xl mb-12 text-center uppercase tracking-widest"
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          About John Danziger
        </motion.h1>

        {/* First section: Image and introduction */}
        <motion.div
          className="flex flex-col items-center mb-16"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <div className="relative w-full md:w-3/4 lg:w-2/3 mb-8">
            <Image
              src="/JohnandLady.png"
              alt="John Danziger"
              width={1200}
              height={800}
              className="border border-white"
            />
          </div>
          <p className="text-lg sm:text-xl text-center max-w-3xl">
            John Danziger is a multi-instrumentalist and composer
             from East Lansing, Michigan. He studies Trombone with 
             Professor Kenneth Thompkins and Composition with Dr. Zhou
              Tian at Michigan State University.
          </p>
        </motion.div>

        {/* Second section: Text on left, horizontal image on right */}
        <motion.div
          className="flex flex-col md:flex-row items-start mb-16"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
        >
          <div className="w-full md:w-1/2 mb-8 md:mb-0 md:pr-8">
            <p className="text-base sm:text-lg mb-4">
              At the age of 5, John began his musical journey with piano
               lessons. Although his childhood dream of becoming a concert 
               pianist didn&apos;t materialize, the skills he developed laid a strong 
               foundation for his diverse musical career. John&apos;s musical repertoire
                expanded in middle school when he took up the cello and bass in the 
                school orchestra. High school brought new opportunities with band, 
                where he learned tuba and bass trombone, while participated in marching band.
            </p>
            <p className="text-base sm:text-lg">
              His high school years were particularly formative, thanks to mentors like his band 
              director, Mr. Larzelere, and orchestra director, Mr. Rosin. They provided John with 
              opportunities to conduct, compose, and premiere his work at the Michigan Music Conference.
            </p>
          </div>
          <div className="w-full md:w-1/2">
            <div className="relative w-full aspect-[4/3]">
              <Image
                src="/Marching.jpeg"
                alt="John Marching"
                fill
                style={{ objectFit: "cover" }}
                className="border border-white"
              />
            </div>
          </div>
        </motion.div>

        {/* Third section: Vertical image on left, text on right */}
        <motion.div
          className="flex flex-col md:flex-row items-start mb-16"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.8 }}
        >
          <div className="w-full md:w-1/3 mb-8 md:mb-0 md:pr-8">
            <div className="relative w-full aspect-[3/4]">
              <Image
                src="/PlayingTrombone.jpeg"
                alt="John Playing Trombone"
                fill
                style={{ objectFit: "cover" }}
                className="border border-white"
              />
            </div>
          </div>
          <div className="w-full md:w-2/3">
            <p className="text-base sm:text-lg mb-4">
              Now at Michigan State University, John plays Bass Trombone with the MSU Symphony Band 
              and Trombone Choir. He also performs with the 5 Guys Brass Quintet. His compositions 
              have been performed by many universities around the country including Columbus State, 
              Boston University, Texas A&M, Iowa State, Colorado State, Texas at Austin University, 
              Texas Rio Grand Valley, Stephen F. Austin University, Michigan State, University of Illinois and more.
              John has also had works premiered and performed at the International Trombone Festival
               in 2024 and 2025.
            </p>
            <p className="text-base sm:text-lg mb-4">
              In addition to festival and university performances,
               John has had other performances including the Réz Körút 
               Brass Septet from Hungary, Principal Trombone of the Grand 
               Rapids Symphony Chris Houlihan, and other solo/chamber works.
            </p>
            <p className="text-base sm:text-lg">
              
              Johns&apos; future plans include becoming a collegiate band 
              director, while continuing to compose and publish his music.
            </p>
          </div>
        </motion.div>

        {/* Contact section */}
        <motion.div
          className="text-center border border-white p-8"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 1 }}
        >
          <p className="text-lg sm:text-xl mb-6">
            For inquiries about commissions, lessons, or gigs, please contact:
          </p>
          <a
            href="mailto:info@johndanziger.com"
            className="text-xl sm:text-2xl hover:underline"
          >
            info@johndanziger.com
          </a>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default AboutPage;
